import qs from 'qs';
import { BASE_CONFIG, getSession, setSession } from '@star/utils';

export class start {
  static appVersion = BASE_CONFIG.appVersion;
  static chanCode = 'MWEB';
  static aseqId = '7';
  static vk = 'fT6phq0wkOPRlAoyToidAnkogUV7ttGo';
  static nc = 1;
  static appWKwebview = BASE_CONFIG.appWKwebview;
  static gameOpenIn = false; // 第三方游戏是否内置打开
  static isWD = 0; // h5是否在微端中,默认不在
  static tid = 0; // RN中url中带有 tid 的
  static clusters_id = 0; // RN中url中带有 clusters_id 的
  // h5的url中带有推荐信息的
  static code = ''; // 推荐码
  static channelCode = ''; // 推广渠道
  static appid = ''; // 推广的包名

  /**
   * 初始化
   * 1、处理了 url 上的各种参数
   * 2、初始化用户的数据
   * 3、注意先后顺序，比如 isApp 中的 appVersion 参数是在url参数初始化过后执行
   */
  static init() {
    // 处理 URL 上的参数
    let urlStr = location.href.split('?')[1];
    if (urlStr) {
      urlStr = urlStr.split('#/')[0];
    }
    // URL 上没有参数
    if (!urlStr) {
      const urlParamsStr = getSession('urlParams');
      if (urlParamsStr) {
        // // 用一次就行了，用于赋值到 config的各个静态变量上
        const tmpObj = JSON.parse(urlParamsStr);
        // 赋值给 config 的静态变量
        Object.keys(tmpObj).forEach(key => {
          this[key] = tmpObj[key];
        });
      }
      return;
    }
    const urlObj = qs.parse(urlStr);
    // url上面的参数
    const urlParams: any = {};
    if (urlObj.appVersion) {
      sessionStorage.setItem('_appVersion', urlObj.appVersion);
      // @ts-ignore
      urlParams.appVersion = urlObj.appVersion;
    }
    urlParams.appVersion = urlParams.appVersion || Number(sessionStorage.getItem('_appVersion')) || -1.0;
    if (urlObj.v) {
      // @ts-ignore
      urlParams.appVersion1 = urlObj.v;
    }
    if (urlObj.vc) {
      // @ts-ignore
      urlParams.versionCode = urlObj.vc;
    }
    if (urlObj.vn) {
      // @ts-ignore
      urlParams.versionName = urlObj.vn;
    }
    if (urlObj.appWKwebview) {
      // @ts-ignore
      urlParams.appWKwebview = urlObj.appWKwebview;
    }
    if (urlObj.vk) {
      // @ts-ignore
      urlParams.vk = urlObj.vk;
    }
    if (urlObj.aseq_id) {
      // @ts-ignore
      urlParams.aseqId = urlObj.aseq_id;
    }
    // 原生现在传值过来的是chan_code
    if (urlObj.chan_code) {
      // @ts-ignore
      urlParams.chanCode = urlObj.chan_code;
      localStorage.setItem('app_chan_code', urlObj.chan_code);
    }
    if (urlObj.route_idx) {
      // @ts-ignore
      urlParams.routeidx = Number(urlObj.route_idx);
    }
    if (urlObj.p) {
      // @ts-ignore
      urlParams.promote = urlObj.p;
    }
    if (urlObj.gameOpenIn) {
      // @ts-ignore
      urlParams.gameOpenIn = urlObj.gameOpenIn;
    }
    if (urlObj.isWD) {
      // @ts-ignore
      urlParams.isWD = urlObj.isWD;
    }
    if (urlObj.h5timeIng || urlObj.h5time) {
      // @ts-ignore
      urlParams.h5DelayKV = { timeIng: urlObj.h5timeIng, time: parseInt(urlObj.h5time) };
    }
    if (urlObj.tid) {
      // @ts-ignore
      urlParams.tid = Number(urlObj.tid);
    }
    if (urlObj.clusters_id) {
      // @ts-ignore
      urlParams.clusters_id = Number(urlObj.clusters_id);
    }
    if (urlObj.code) {
      // @ts-ignore
      urlParams.code = urlObj.code;
    }
    if (urlObj.channelCode) {
      // @ts-ignore
      urlParams.channelCode = urlObj.channelCode;
    }
    if (urlObj.appid) {
      // @ts-ignore
      urlParams.appid = urlObj.appid;
    }

    // 处理有参数的情况
    if (Object.keys(urlParams).length > 0) {
      // 赋值给 config 的静态变量
      Object.keys(urlParams).forEach(key => {
        this[key] = urlParams[key];
      });
      setSession('urlParams', JSON.stringify(urlParams));
    }
  }
}
